import { Route } from "react-router-dom";
import { Login } from "./components/Login";
import { Signup } from "./components/signup";
import { ForgotPassword } from "../users/components/forgot-password/ForgotPassword";

export function AuthRoutes() {
  return (
    <>
      <Route path="login" element={<Login />} />
      <Route path="signup" element={<Signup />} />
      <Route path="forgot-password" element={<ForgotPassword />} />
    </>
  );
}
